import { render, staticRenderFns } from "./SystemCardTemplate.vue?vue&type=template&id=0a1e23a9&scoped=true"
import script from "./SystemCardTemplate.vue?vue&type=script&lang=js"
export * from "./SystemCardTemplate.vue?vue&type=script&lang=js"
import style0 from "./SystemCardTemplate.vue?vue&type=style&index=0&id=0a1e23a9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1e23a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a1e23a9')) {
      api.createRecord('0a1e23a9', component.options)
    } else {
      api.reload('0a1e23a9', component.options)
    }
    module.hot.accept("./SystemCardTemplate.vue?vue&type=template&id=0a1e23a9&scoped=true", function () {
      api.rerender('0a1e23a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/System/SystemCardTemplate/SystemCardTemplate.vue"
export default component.exports